export interface State {
  lastActivityTimestamp: number;
  showTimeoutWarning: boolean;
}

export const initialState: State = {
  lastActivityTimestamp: Date.now(),
  showTimeoutWarning: false
};

export const RECORD_ACTIVITY = 'sessionActivity/RECORD_ACTIVITY';
const SHOW_TIMEOUT_WARNING = 'sessionActivity/SHOW_TIMEOUT_WARNING';
export const CHECK_TIMEOUT = 'sessionActivity/CHECK_TIMEOUT';
export const RESET_TIMEOUT = 'sessionActivity/RESET_TIMEOUT';

export const recordActivity = () => ({type: RECORD_ACTIVITY});

export const showTimeoutWarning = () => ({type: SHOW_TIMEOUT_WARNING});

export const resetTimeout = () => ({type: RESET_TIMEOUT});

export const checkTimeout = () => ({type: CHECK_TIMEOUT});

/**
 * Given a current state, perform the action provided and return a new state.
 * @param state Current state. Defaults to initial state.
 * @param action Action that was dispatched.
 * @returns A new state.
 */
const sessionActivity = (state: State = initialState, action: any) => {
  // record latest activity timestamp after any other actions
  const shouldRecordActivity = ![CHECK_TIMEOUT, SHOW_TIMEOUT_WARNING].includes(action.type);
  const newState = {...state, ...(shouldRecordActivity ? {lastActivityTimestamp: Date.now()} : {})};

  switch (action.type) {
    case SHOW_TIMEOUT_WARNING:
      return {...newState, showTimeoutWarning: true};

    case RESET_TIMEOUT:
      return {...newState, showTimeoutWarning: false};

    default:
      return newState;
  }
};

export default sessionActivity;
